import React from "react";
import {
  Box,
  Grid,
  Typography,
  Card,
  CardMedia,
  CardActionArea,
  Container,
} from "@mui/material";

const gold = "#C29D59";
const darkBg = "#111";

const projects = [
  {
    title: "Modern Residential Living",
    category: "Residential",
    image: "/images/project-a.jpg",
  },
  {
    title: "Contemporary Office Interior",
    category: "Commercial",
    image: "https://images.unsplash.com/photo-1505691723518-36a5ac3be353?auto=format&fit=crop&w=1000&q=80",
  },
  {
    title: "Luxury Bedroom Design",
    category: "Residential",
    image: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=1000&q=80",
  },
  {
    title: "Minimalist Apartment Decor",
    category: "Residential",
    image: "/images/about-a.jpg",
  },
  {
    title: "Elegant Lounge Area",
    category: "Commercial",
    image: "/images/project-b.jpg",
  },
  {
    title: "Cozy Scandinavian Home",
    category: "Residential",
    image: "https://images.unsplash.com/photo-1615874959474-d609969a20ed?auto=format&fit=crop&w=1000&q=80",
  },
];

const Projects = () => {
  return (
    <Container
        maxWidth={false}
        sx={{
          maxWidth: "1450px !important",
          mx: "auto",
          px: { xs: 2, md: 4 },
        }}
      >
 <Box
      component="section"
      id="projects"
      sx={{
        py: { xs: 10, md: 14 },
        
        backgroundColor: darkBg,
        color: "#fff",
        textAlign: "center",
      }}
    >
      {/* Header */}
      <Typography
        variant="subtitle2"
        sx={{
          color: gold,
          fontWeight: 600,
          textTransform: "uppercase",
          letterSpacing: 1,
          mb: 2,
        }}
      >
        Our Portfolio
      </Typography>

      <Typography
        variant="h3"
        sx={{
          fontWeight: 700,
          mb: 2,
          fontSize:{sm:"45px",xs:"32px"}
        }}
      >
        Featured{" "}
        <Box component="span" sx={{ color: gold }}>
          Projects
        </Box>
      </Typography>

      <Typography
        variant="body1"
        sx={{
          maxWidth: 700,
          mx: "auto",
          mb: 8,
          color: "rgba(255,255,255,0.7)",
          lineHeight: 1.7,
          
        }}
      >
        Explore our carefully curated collection of completed projects that
        showcase our design expertise and commitment to excellence.
      </Typography>

      {/* Project Cards Grid */}
      <Grid container spacing={7} justifyContent="center">
        {projects.map((project) => (
          <Grid item xs={12} sm={6} md={4} key={project.title}>
            <Card
              sx={{
                borderRadius: 3,
                overflow: "hidden",
                position: "relative",
                backgroundColor: "transparent",
                border: "1px solid rgba(255,255,255,0.1)",
                transition: "transform 0.3s ease, border-color 0.3s ease",
               
                "&:hover": {
                  borderColor: gold,
                  transform: "translateY(-6px)",
                },
              }}
            >
              <CardActionArea
                sx={{
                  position: "relative",
                  "&:hover .overlay": { opacity: 1, transform: "translateY(0)" },
                }}
              >
               <CardMedia
  component="img"
  image={project.image}
  alt={project.title}
  sx={{
    width: "400px",        // ✅ correct way
    height: "450px",
    objectFit: "cover",
    mx: "auto",            // centers the image if inside a flex/grid
    transition: "transform 0.5s ease",
    "&:hover": { transform: "scale(1.05)" },
  }}
/>


                {/* Hover Overlay */}
                <Box
                  className="overlay"
                  sx={{
                    position: "absolute",
                    inset: 0,
                    background:
                      "linear-gradient(to top, rgba(0,0,0,0.8), rgba(0,0,0,0.2))",
                    color: "#fff",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-end",
                    alignItems:"start",
                    p: 3,
                    opacity: 0,
                    transform: "translateY(20px)",
                    transition: "all 0.3s ease",
                  }}
                >
                  <Typography
                    variant="subtitle2"
                    sx={{
                      color: gold,
                      fontWeight: 600,
                      mb: 0.5,
                    }}
                  >
                    {project.category}
                  </Typography>
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 700,
                    }}
                  >
                    {project.title}
                  </Typography>
                </Box>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
      </Container>
   
  );
};

export default Projects;
